import { Box, Heading, Link, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import MarketingPageShell, {
  breadcrumbSchema,
} from '../../components/MarketingPageShell';
import { SITE_URL } from '../../components/PageMeta';
import { getAllPosts } from '../../lib/blog';

const BREADCRUMBS = [
  { name: 'Home', path: '/' },
  { name: 'Blog', path: '/blog' },
];

const INDEX_DESCRIPTION =
  'Sports betting analytics blog from WagerWatchdog — weekly expert performance data, verified pick outcomes, and transparent scoring.';

export default function BlogIndex() {
  const posts = getAllPosts();

  return (
    <MarketingPageShell
      fullTitle="WagerWatchdog Blog | Sports Betting Analytics & Weekly Data"
      description={INDEX_DESCRIPTION}
      schema={[
        {
          '@context': 'https://schema.org',
          '@type': 'Blog',
          name: 'WagerWatchdog Blog',
          description: INDEX_DESCRIPTION,
          url: `${SITE_URL}/blog`,
          publisher: {
            '@type': 'Organization',
            name: 'IvoryShoulder, LLC',
            alternateName: 'WagerWatchdog',
          },
        },
        {
          '@context': 'https://schema.org',
          ...breadcrumbSchema(BREADCRUMBS),
        },
      ]}
      breadcrumbs={BREADCRUMBS}
      h1="WagerWatchdog"
      h1Accent="Blog"
      lead="Weekly sports betting analytics from verified expert picks — who actually won, by sport and bet type."
    >
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} w="full">
        {posts.map((post) => (
          <Box
            key={post.slug}
            as="article"
            p={{ base: 6, md: 7 }}
            bg="gray.800"
            borderRadius="16px"
            border="1px solid"
            borderColor="whiteAlpha.100"
            transition="all 0.2s"
            _hover={{
              borderColor: 'primary.500',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 30px rgba(10, 112, 185, 0.12)',
            }}
          >
            <VStack align="start" spacing={3}>
              <Text fontSize="xs" color="gray.500" textTransform="uppercase">
                {post.date}
                {post.category ? ` · ${post.category}` : ''}
              </Text>
              <Heading as="h2" fontSize="xl" color="white">
                <Link
                  as={RouterLink}
                  to={`/blog/${post.slug}`}
                  _hover={{ color: 'primary.400', textDecoration: 'none' }}
                >
                  {post.title}
                </Link>
              </Heading>
              <Text color="gray.400" fontSize="sm" lineHeight="1.7">
                {post.excerpt}
              </Text>
              <Link
                as={RouterLink}
                to={`/blog/${post.slug}`}
                color="primary.400"
                fontSize="sm"
                fontWeight="semibold"
              >
                Read more →
              </Link>
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
      {posts.length === 0 ? (
        <Text color="gray.500">No posts yet. Check back soon.</Text>
      ) : null}
    </MarketingPageShell>
  );
}
